module.exports = __webpack_public_path__ + "img/icon-truck.1b649450.svg";